import axios from 'axios';

export async function uploadDocument(baseUri: string, file: File, onUploadProgress: any) {
  const formData = new FormData();
  formData.append('file', file);

  const queryString = new URLSearchParams({
    FileName: file.name,
  }).toString();

  const { data } = await axios.post(`${baseUri}Document/UploadDocument?${queryString}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });

  return data;
}

export async function deleteDocument(baseUri: string, documentId: string) {
  const queryString = `documentId=${documentId}`;

  return await fetch(`${baseUri}Document/DeleteDocument?${queryString}`, {
    method: 'DELETE',
  });
}

export async function getDocument(baseUri: string, documentId: string) {
  const url = `${baseUri}Document/GetDocument?documentId=${documentId}`;
  window.open(url, '_blank', 'noreferrer');
}
